























import Card from '@/components/Card.vue'
import { Vue, Component, Prop, Watch, Mixins } from "vue-property-decorator";
import ModalBase from '@/components/ModalBase.vue';

@Component({
  components: {
    Card,
    ModalBase
  }
})

export default class AddressErrorModal extends Vue {}
